const container = document.querySelector(".js-read-more");
const readmore = document.querySelector(".js-read-more__text");
const btnOpen = document.querySelector(".js-read-more__open");
const btnClose = document.querySelector(".js-read-more__close");

function init() {
  textHeight = readmore.scrollHeight;
  // 100 correspond au max-height définit dans read-more.scss
  if (textHeight < 100) {
    btnOpen.classList.add('d-none');
    btnClose.classList.add('d-none');
  }
}

if (container) {
  init();
  btnOpen.addEventListener("click", function () {
    textHeight = readmore.scrollHeight;
    readmore.style.maxHeight = textHeight + "px";
    container.classList.add("active");
  });

  btnClose.addEventListener("click", function () {
    readmore.style.removeProperty('max-height');
    container.classList.remove("active");
  });
}

window.addEventListener("resize", function () {
  if (container) {
    if (container.classList.contains("active")) {
      textHeight = readmore.scrollHeight;
      readmore.style.maxHeight = textHeight + "px";
    }
    init();
  }
});
